import { toast } from "sonner";
import configuration from "~/configuration";
import SecondaryButton from "~/designSystem/components/Buttons/SecondaryButton";
import Icon from "~/designSystem/components/Icon";
import {
  StyledLeadingTrimEdgeAnchor,
  StyledLeadingTrimEdgeText,
} from "~/designSystem/components/Text/components/styled";
import { COLOR_TOKENS } from "~/designSystem/constants/token";

import If from "~/core/ui/If";

type ObjectRecordCreateSonnerProps = {
  title: string;
  href?: string;
  toastId: string;
  description?: string;
  viewButtonLabel?: string;
};

export default function ObjectRecordCreateSonner({
  title,
  href,
  toastId,
  description,
  viewButtonLabel = "View",
}: ObjectRecordCreateSonnerProps) {
  const dismiss = () => {
    toast.dismiss(toastId);
  };

  return (
    <div className="w-full space-y-2">
      <div className="flex items-center gap-1">
        <Icon
          name="CheckCircle_12_Fill"
          color={COLOR_TOKENS.status.success.a8}
        />
        <StyledLeadingTrimEdgeText className="text-core-silver-a12 text-size-2 font-text font-medium">
          {title}
        </StyledLeadingTrimEdgeText>
      </div>
      <If condition={description}>
        <StyledLeadingTrimEdgeAnchor
          className="text-core-blue-a9 hover:text-core-blue-a10 hover:underline text-size-1 font-text truncate"
          href={href!}
          onClick={dismiss}
        >
          {description}
        </StyledLeadingTrimEdgeAnchor>
      </If>

      <div className="flex items-center gap-2">
        <If condition={!!href}>
          <SecondaryButton
            size="x-small"
            href={href!}
            icon12pxLeft="ArrowPerspDoorIn_12_Outline"
            label={viewButtonLabel}
            onClick={dismiss}
          />
          <SecondaryButton
            size="x-small"
            onClick={async () => {
              const url = configuration.site.siteUrl + href!;
              try {
                await navigator.clipboard.writeText(url);
                toast.success("Link copied to clipboard");
              } catch (error) {
                toast.error("Failed to copy link to clipboard");
              }
              dismiss();
            }}
            icon12pxLeft="Link4_12_Outline"
            label="Copy link"
          />
        </If>
      </div>
    </div>
  );
}
